import { gql } from '@apollo/client';

export const createFacilitySignOutFromPhone = gql`
  mutation createFacilitySignOutFromPhone(
    $facilityId: String!
    $phoneNumber: String!
  ) {
    createFacilitySignOutFromPhone(
      facilityId: $facilityId
      phoneNumber: $phoneNumber
    )
  }
`;
